import {
    FontLoader,
    ShapeGeometry,
    Mesh,
    Texture,
    MeshBasicMaterial,
    DoubleSide,
    PlaneGeometry,
    CubeUVReflectionMapping,
    RepeatWrapping
} from 'three'

const textureCache = new Map();

/*****************************************************************
 *  Text Provider
 * ***************************************************************/


 
const
    /**
    * return a ratio for different screen
    * @returns {number}
    */
    getMarkupDisplayRatio = () => window.innerWidth <= 932 ? 2 : 1,
    textLoader = new FontLoader()

export const disposeTextProvider = () => {
    textureCache.forEach(texture => texture.dispose());
    textureCache.clear();
}


 /**
  * Provide TextMesh
  * @param {string} message
  */
export const getText = message => new Promise((resolve, reject) => {
    textLoader.load(
        'fonts/helvetiker_regular.typeface.json',
        ( font ) => {
            const shapes = font.generateShapes( message, 10 )
            const geometry = new ShapeGeometry( shapes )
            geometry.computeBoundingBox()
            const xMid = - 0.5 * ( geometry.boundingBox.max.x - geometry.boundingBox.min.x )
            geometry.translate( xMid, 0, 0 )
            resolve(new Mesh( geometry ))
        } ,
        null,
        ( error ) => {
            console.error( error )
            reject(error)
        }
    )
})

/**
 * Provide Label with text Mesh
 * @param {string} message
 * @param {string} name
 * @returns object
 */
export const getTextUre = ( message, name ) => new Promise( resolve => {

    let createCanvas = message => new Promise( (resolve) => {
        var bitmap = document.createElement('canvas')
        var g = bitmap.getContext('2d')
        const multiple = getMarkupDisplayRatio()
        bitmap.width = 140 * multiple
        bitmap.height = 80 * multiple
        g.font = `Bold ${60 * multiple}px Arial`

        g.fillStyle = 'white'
        g.fillText(message, 10 * multiple, 60 * multiple)
        g.strokeStyle = 'black'
        g.strokeText(message, 10 * multiple, 60 * multiple)

        resolve( bitmap )
    } )

    let createTexture = message => {
        const cacheKey = `${message}_${name}`;
        if (textureCache.has(cacheKey)) {
            return Promise.resolve(textureCache.get(cacheKey));
        }
        
        return createCanvas(message).then(canvas => {
            const texture = new Texture(canvas);
            texture.wrapS = RepeatWrapping;
            texture.wrapT = RepeatWrapping;
            texture.mapping = CubeUVReflectionMapping;
            texture.needsUpdate = true;
            textureCache.set(cacheKey, texture);
            return texture;
        });
    }

    let createMesh = message => createTexture( message ).then( texture =>
        new Promise ( resolve => {
            let material = new MeshBasicMaterial( { map: texture, side: DoubleSide } )
            let geometry = new PlaneGeometry( 0.2, 0.1 )

            resolve( {geometry, material} )
        })
    )

    let setupMesh = message => createMesh( message ).then( ({geometry, material}) =>
        new Promise ( resolve => {
            let mesh = new Mesh( geometry, material )
            const size = 10 * getMarkupDisplayRatio()
            mesh.scale.set(size, size, size)
            mesh.userData.baseScale = size
            mesh.name = 'Marker-'+name+'-'+message
            mesh.userData.keyframes = []
            resolve( mesh )
        })
    )

    resolve( setupMesh( message ) )
})
